module.exports = __webpack_public_path__ + "static/img06__sp-4176bfc2221d35333b59b1971b547cec.svg";